// Consistent app-wide date display: e.g. 25-Sep-1980
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatDisplayDate(value) {
  if (!value) return '';
  const s = String(value).trim();

  // Handle plain date strings (YYYY-MM-DD) without timezone shift
  const dateOnly = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  let y, m, d;
  if (dateOnly) {
    y = Number(dateOnly[1]);
    m = Number(dateOnly[2]);
    d = Number(dateOnly[3]);
  } else {
    // Handle legacy DD-MM-YYYY / DD.MM.YYYY / DD/MM/YYYY (day first, 4-digit year)
    const dmy = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
    if (dmy) {
      d = Number(dmy[1]);
      m = Number(dmy[2]);
      y = Number(dmy[3]);
    } else {
      const dt = new Date(s);
      if (isNaN(dt.getTime())) return s; // unknown format -> show as-is
      y = dt.getFullYear();
      m = dt.getMonth() + 1;
      d = dt.getDate();
    }
  }

  if (!y || !m || !d || m < 1 || m > 12) return s;
  return `${String(d).padStart(2, '0')}-${MONTHS[m - 1]}-${y}`;
}

// Date + time display, e.g. 25-Sep-1980, 10:30 AM
export function formatDisplayDateTime(value) {
  if (!value) return '';
  const dt = new Date(value);
  if (isNaN(dt.getTime())) return formatDisplayDate(value);
  const time = dt.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  return `${formatDisplayDate(value)}, ${time}`;
}

// Age in whole years from a date of birth (supports YYYY-MM-DD, ISO, DD-MM-YYYY/DD.MM.YYYY/DD/MM/YYYY)
export function computeAge(dob) {
  if (!dob) return null;
  const s = String(dob).trim();
  let y, m, d;
  let mt = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (mt) { y = +mt[1]; m = +mt[2]; d = +mt[3]; }
  else {
    mt = s.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
    if (mt) { d = +mt[1]; m = +mt[2]; y = +mt[3]; }
    else {
      const dt = new Date(s);
      if (isNaN(dt.getTime())) return null;
      y = dt.getFullYear(); m = dt.getMonth() + 1; d = dt.getDate();
    }
  }
  if (!y || !m || !d) return null;
  const today = new Date();
  let age = today.getFullYear() - y;
  const beforeBirthday = (today.getMonth() + 1) < m || ((today.getMonth() + 1) === m && today.getDate() < d);
  if (beforeBirthday) age -= 1;
  return age >= 0 && age < 140 ? age : null;
}
